/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * List of Tickets.
 */
export interface TicketResult { 
    /**
     * Id Hash. UTI (Unique Ticket Identifier). Maximum lenght 88.
     */
    idHash?: string;
    /**
     * Id Hash. UTTI (Unique Ticket Type Identifier). Maximum lenght 88.
     */
    idHashTicketType?: string;
    /**
     * Id Hash. UUI (Unique User Identifier). Maximum lenght 88.
     */
    idHashUser?: string;
    /**
     * Status
     */
    status?: string;
    /**
     * The creation date of the ticket. Format yyyy-MM-dd HH:mm:ss
     */
    creationDate?: string;
    /**
     * Fiat price for resaling the ticket.
     */
    fiatResalePrice?: number;
    /**
     * Crypto price for resaling the ticket.
     */
    cryptoResalePrice?: number;
    /**
     * Section. Maximum lenght 20
     */
    section?: string;
    /**
     * Section. Maximum lenght 20
     */
    row?: string;
    /**
     * Section. Maximum lenght 20
     */
    seat?: string;
    /**
     * Featured image
     */
    featuredImage?: string;
}

